/**
 * External dependencies
 */
import { HslColorPicker, HslaColorPicker } from 'react-colorful';

/**
 * Internal dependencies
 */
import { jsx as _jsx } from "react/jsx-runtime";
// Pointer capture fortifies drag gestures so that they continue to work
// while dragging outside the component over objects like iframes. If a
// newer version of react-colorful begins to employ pointer capture this
// will be redundant and should be removed.
const pointerCaptureProps = {
  onPointerDown({
    currentTarget,
    pointerId
  }) {
    currentTarget.setPointerCapture(pointerId);
  },
  onPointerUp({
    currentTarget,
    pointerId
  }) {
    currentTarget.releasePointerCapture(pointerId);
  }
};
export const Picker = ({
  hsla,
  enableAlpha,
  onChange
}) => {
  if (enableAlpha) {
    return /*#__PURE__*/_jsx(HslaColorPicker, {
      color: hsla,
      onChange: onChange,
      ...pointerCaptureProps
    });
  }
  return /*#__PURE__*/_jsx(HslColorPicker, {
    color: hsla,
    onChange: nextColor => {
      onChange({
        ...nextColor,
        a: hsla.a
      });
    },
    ...pointerCaptureProps
  });
};